import { render, staticRenderFns } from "./chat-list.vue?vue&type=template&id=22dd1a4e&scoped=true&"
import script from "./chat-list.vue?vue&type=script&lang=js&"
export * from "./chat-list.vue?vue&type=script&lang=js&"
import style0 from "./chat-list.vue?vue&type=style&index=0&id=22dd1a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd1a4e",
  null
  
)

export default component.exports